// session-timeout.providers.ts
import { createSessionTimeoutProviders } from 'ng2-idle-timeout'
import { SessionTimeoutPartialConfig } from 'ng2-idle-timeout';

export const defaultSessionTimeoutConfig: SessionTimeoutPartialConfig = {
  storageKeyPrefix: 'app-session',
  idleGraceMs: 5 * 60 * 1_000,
  countdownMs: 60 * 60 * 1_000,
  warnBeforeMs: 10 * 60 * 1_000,
  activityResetCooldownMs: 5 * 60 * 1_000,
  resumeBehavior: 'autoOnServerSync',
  resetOnWarningActivity: false
};

export const sessionTimeoutProviders = createSessionTimeoutProviders(defaultSessionTimeoutConfig);
